import { render } from "./VBookingDetails.vue?vue&type=template&id=5a6c87d8"
import script from "./VBookingDetails.vue?vue&type=script&lang=js"
export * from "./VBookingDetails.vue?vue&type=script&lang=js"

import exportComponent from "/apps/releases/202604221556/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/platform/components/offline-booking/VBookingDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a6c87d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a6c87d8', __exports__)) {
    api.reload('5a6c87d8', __exports__)
  }
  
  module.hot.accept("./VBookingDetails.vue?vue&type=template&id=5a6c87d8", () => {
    api.rerender('5a6c87d8', render)
  })

}


export default __exports__